import { declareParams } from '@farfetched/core';
import { zodContract } from '@farfetched/zod';
import { createAuthMutation } from '../auth-http-client';
import { JackpotType, addJackpotResponseSchema } from '../types';

export type AddJackpotMutationParams = {
	accountId: number;
	gameId: number;
	currency: string;
	type: JackpotType;
	betRate: number;
	initialAmount: number;
	limitAmount: number;
};

export const createAddJackpotMutation = () =>
	createAuthMutation({
		params: declareParams<AddJackpotMutationParams>(),
		request: {
			method: 'POST',
			url: '/jackpot',
			body: (data) => data,
		},
		response: {
			contract: zodContract(addJackpotResponseSchema),
		},
	});
